import React from 'react';
import { Stack } from '@mui/material';
import { FacilityReportSummaryView } from '../../../../../services/ReportingService';
import { TotalTicketsCard, OpenTicketsCard, AvgDaysToRespondCard, AvgDaysToRepairCard } from '../../charts';

interface WorkOrderReportSummaryCardsProps {
  summaryData: FacilityReportSummaryView;
}

const WorkOrderReportSummaryCards: React.FC<WorkOrderReportSummaryCardsProps> = ({ summaryData }) => {
  return (
    <Stack
      spacing={2}
      direction={{ xs: 'column', sm: 'row' }}
      sx={{
        maxWidth: 1200,
        mx: 'auto',
        mb: 3,
        flexWrap: { sm: 'wrap', lg: 'nowrap' },
      }}
    >
      <TotalTicketsCard value={summaryData.totalTickets} />
      <OpenTicketsCard value={summaryData.openTickets} />
      <AvgDaysToRespondCard value={summaryData.averageDaysToRespond} />
      <AvgDaysToRepairCard value={summaryData.averageDaysToRepair} />
    </Stack>
  );
};

export default WorkOrderReportSummaryCards;
